const MAX_ENTRIES = 100;

const PAGE_NAMES = {
  "/":                 "Accueil",
  "/login":            "Page Connexion",
  "/register":         "Page Inscription",
  "/client":           "Mes Crushs",
  "/dashboard":        "Tableau de bord vendeur",
  "/products":         "Produits publics",
  "/scan":             "Scanner",
  "/about":            "A propos",
  "/cgu":              "CGU",
  "/legal":            "Mentions legales",
  "/mentions":         "Mentions",
  "/mentions-legales": "Mentions legales",
  "/privacy":          "Confidentialite",
  "/faq":              "FAQ",
  "/evolutions":       "Journal des modifications",
  "/landing":          "Presentation",
  "/feedback":         "Feedback",
  "/map":              "Carte",
  "/mes-produits":     "Mes produits",
  "/my-data":          "Mes donnees",
  "/recover":          "Recuperation compte",
  "/recover-account":  "Recuperation compte",
  "/forgot-password":  "Mot de passe oublie",
  "/reset-password":   "Reinitialisation mot de passe",
};

export function resolvePageName(pathname) {
  if (PAGE_NAMES[pathname]) return PAGE_NAMES[pathname];
  if (pathname.startsWith("/barcode/"))           return "Fiche produit barcode";
  if (pathname.startsWith("/product/"))           return "Fiche produit";
  if (pathname.startsWith("/community-product/")) return "Produit communautaire";
  return pathname;
}

// In-memory — scoped to the current JS session, no async race conditions
let _log = [];

export function trackPage(pageName) {
  _log.push({ type: "page", label: pageName, url: window.location.href, timestamp: new Date().toISOString() });
  if (_log.length > MAX_ENTRIES) _log = _log.slice(-MAX_ENTRIES);
}

export function trackAction(label) {
  _log.push({ type: "action", label: "Clic : " + label, url: window.location.href, timestamp: new Date().toISOString() });
  if (_log.length > MAX_ENTRIES) _log = _log.slice(-MAX_ENTRIES);
}

export function getSessionLog() {
  return [..._log];
}

export function clearSessionLog() {
  _log = [];
}
